"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleTransport = void 0;
var ConsoleTransport = /** @class */ (function () {
    function ConsoleTransport() {
    }
    ConsoleTransport.prototype.send = function (sendable) {
        return new Promise(function (resolve, reject) {
            console.log(sendable.toSendable());
            resolve(true);
        });
    };
    return ConsoleTransport;
}());
exports.ConsoleTransport = ConsoleTransport;
